import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Spinner,
  Text,
  VStack,
} from '@chakra-ui/react';
import type { Country } from '@/models/country';
import { CountryListGrid } from '../CountryListGrid';

export function ViewMemberListModal(props: {
  isOpen: boolean;
  onClose: () => void;
  /** Reopens this modal after team detail closes (paired with list dismiss on team pick). */
  onReopen: () => void;
  memberName: string;
  countryList: Country[] | null;
  loading: boolean;
  error: string | null;
}) {
  const { isOpen, onClose, onReopen, memberName, countryList, loading, error } = props;

  return (
    <Modal isOpen={isOpen} onClose={onClose} size='lg' scrollBehavior='inside'>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{memberName}&apos;s list</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6}>
          {loading ? (
            <VStack py={8}>
              <Spinner />
              <Text fontSize='sm' color='gray.500'>
                Loading list…
              </Text>
            </VStack>
          ) : error ? (
            <Text fontSize='sm' color='red.500'>
              {error}
            </Text>
          ) : countryList && countryList.length === 10 ? (
            <CountryListGrid
              countryList={countryList}
              svg
              compactMobile
              teamDetailSource='league'
              parentModalHandoff={{ onDismiss: onClose, onResume: onReopen }}
            />
          ) : (
            <Text fontSize='sm' color='gray.500'>
              No list to display.
            </Text>
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
